import { FormControl, InputLabel, MenuItem, Select, } from "@mui/material";
import { Controller } from "react-hook-form";

type ControlledInputPropType = {
    name: string, control: any, label: string, errors: any, size?: number, width?: string, options: any, setValue?: any, disabled?: boolean
}
export const ControlledSelectInput = ({ disabled, name, control, label, errors, size = 4, width, options }: ControlledInputPropType) => {

    return (
        <Controller
            name={name}
            control={control}
            render={({ field: { onChange, value } }) => (
                <FormControl sx={{ width: width ? width : "100%" }} >
                    <InputLabel id={name}>{label}</InputLabel>
                    <Select
                        disabled={disabled}
                        labelId={name}
                        onChange={onChange}
                        value={value}
                        label={label}
                        error={errors[name] && Boolean(errors[name].message)}
                        sx={{ height: "2.5rem" }}
                    >
                        {options.map((option: any, index: number) => {
                            return <MenuItem key={index} value={option.value}>{option.label}</MenuItem>
                        })}

                    </Select>
                </FormControl>
            )}
        />

    );
}